/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An A (3 cr), B+ (4 cr) and A- (3 cr) give a GPA of 3.63.`)
};

const es_gpa_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una A (3 cr), B+ (4 cr) y A- (3 cr) dan un promedio de 3.63.`)
};

const de_gpa_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein A (3 Cr), B+ (4 Cr) und A- (3 Cr) ergeben einen GPA von 3,63.`)
};

const nl_gpa_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een A (3 sp), B+ (4 sp) en A- (3 sp) geven een GPA van 3,63.`)
};

const fr_gpa_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un A (3 cr), un B+ (4 cr) et un A- (3 cr) donnent un GPA de 3,63.`)
};

const it_gpa_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una A (3 cr), una B+ (4 cr) e una A- (3 cr) danno un GPA di 3,63.`)
};

const pt_br2_gpa_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um A (3 cr), B+ (4 cr) e A- (3 cr) dão um GPA de 3,63.`)
};

const pt_gpa_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um A (3 cr), B+ (4 cr) e A- (3 cr) dão um GPA de 3,63.`)
};

const ja_gpa_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A(3単位)、B+(4単位)、A-(3単位)の場合、GPAは3.63になります。`)
};

const zh_gpa_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一门 A（3 学分）、一门 B+（4 学分）和一门 A-（3 学分），GPA 为 3.63。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_ex1", locale)
	if (locale === "en") return en_gpa_ex1(inputs)
	if (locale === "es") return es_gpa_ex1(inputs)
	if (locale === "de") return de_gpa_ex1(inputs)
	if (locale === "nl") return nl_gpa_ex1(inputs)
	if (locale === "fr") return fr_gpa_ex1(inputs)
	if (locale === "it") return it_gpa_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_ex1(inputs)
	if (locale === "pt") return pt_gpa_ex1(inputs)
	if (locale === "ja") return ja_gpa_ex1(inputs)
	return zh_gpa_ex1(inputs)
};